import { toggleBlockType } from "tiptap-commands";
import { Node } from "tiptap";

let GET_ATTRS = function(tag, dom) {
  // console.log("PARSE-DOM:", tag, dom);
  let userData = [];
  if (dom.getAttributeNames) {
    let keys = dom.getAttributeNames();
    if (!keys) { keys = [] };
    keys.forEach(key => {
      if (
        key.length > 5 && key.substring(0, 5) === "data-" &&
        !(key.length > 7 && key.substring(0, 7) === "data-v-")) {
        userData.push({ key: key, value: dom.getAttribute(key) });
      }
    });
  }
  else {
    for(let ninx = 0, attrs = dom.attributes; ninx < attrs.length; ninx++) {
      let key = attrs[ninx].name;
      if (
        key.length > 5 && key.substring(0, 5) === "data-" &&
        !(key.length > 7 && key.substring(0, 7) === "data-v-")) {
        userData.push({ key: key, value: dom.getAttribute(key) });
      }
    }
  }
  let textAlign = dom.style.textAlign || "left";

  let ret = {
    id: dom.getAttribute("id"),
    tag: dom.nodeName.toLowerCase(),
    // tag: tag,
    class: dom.getAttribute("class"),
    style: dom.getAttribute("style"),
    userData: userData,
    textAlign: textAlign,
  };
  // console.log("RET:", JSON.stringify(ret));
  return ret;
};

export default class Paragraph extends Node {
	get name() {
		return "paragraph";
	}

	get schema() {
		return {
			attrs: {
        id: { default: null },
        tag: { default: "p" },
        class: { default: null },
        style: { default: null },
        userData: { default: [] },
				textAlign: { default: "left" }
			},
			content: "inline*",
			group: "block",
			draggable: false,
			parseDOM: [
				{
					tag: "p",
					getAttrs(dom) { return GET_ATTRS("p", dom); },
				},
				{
					tag: "h2",
					getAttrs(dom) { return GET_ATTRS("h2", dom); },
				},
				{
					tag: "h3",
					getAttrs(dom) { return GET_ATTRS("h3", dom); },
				},
			],
      toDOM: (node) => {
        // console.log("TO-DOM:", node.attrs.tag, node.textContent);
        let style = "";
        if (node.attrs.style) {
          style += node.attrs.style;
        }
        if (node.attrs.textAlign) {
          if (style) {
            style = style.replace(/text-align\s*:\s*(left|right|center)\s*[;]{0,1}/ig,"") + ";";
            style = style.replace(/^[;]+/, "");
          }
          style += "text-align:" + node.attrs.textAlign;
        }
        let attrs = {
          id: node.attrs.id,
          class: node.attrs.class,
          style: style,
        };
        if (node.attrs.userData) {
          node.attrs.userData.forEach(item => {
            attrs[item.key] = item.value;
          });
        }
        return [
          node.attrs.tag, 
          attrs,
          0
        ];
      }
		};
	}

	commands({ type, schema }) {
		return (attrs) => {
      // console.log("COMMAND:", type, schema, attrs);
      return toggleBlockType(type, schema.nodes.paragraph, attrs);
    }
	}
}


// WEBPACK FOOTER //
// ./src/components/cowork/general/board/extensions/Paragraph.js